/* eslint-disable camelcase */
import cloneDeep from 'lodash/cloneDeep';
import { defaultState as queryParamsDefaultState } from '../../search/state/reducers/queryParams';
import { convertUrlParamsToSearchState } from '../../search/state/utils/convertUrlParamsToSearchState';
import { defaultState as hiddenFeaturesDefaultState } from '../../hidden-features/reducers/hiddenFeatures';

export const getDefaultState = (
  url: string,
  {
    daysRemaining,
    accessPremium = true,
  }: {
    daysRemaining?: number;
    accessPremium?: boolean;
  },
) => {
  const queryParamsState = convertUrlParamsToSearchState(url);
  const queryParams = {
    ...cloneDeep(queryParamsDefaultState),
    ...queryParamsState,
  };

  return {
    queryParams,
    user: {
      quotaExceeded: false,
      accessPremium,
      /** DEPRECATED : use currentUser.status in user context instead
       * and compare with userStatusConstants */
      trialExpired: !accessPremium && !!daysRemaining && daysRemaining === 0,
    },
    aggregationsTree: { selectedPanes: queryParams.aggregationsPaths },
    hiddenFeatures: hiddenFeaturesDefaultState,
  };
};
